<template>
  <Container type="card-full">
    <!-- <div slot="header" v-if="$route.params.innerbtn.length">
      <vxe-button v-for="(btn) in this.$route.params.innerbtn" :key="btn.btncode" icon='el-icon-connection' status="">
        {{btn.btnname}}
      </vxe-button>
    </div> -->
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">单位名称</div>
              <div class="view-value">{{com.comfullname}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">单位类型</div>
              <div class="view-value">{{com.comtypename}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">统一信用代码</div>
              <div class="view-value">{{com.comidcode}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">手机号码</div>
              <div class="view-value">{{com.commobile}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">联系人</div>
              <div class="view-value">{{com.comcontact}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">单位电话</div>
              <div class="view-value">{{com.comtel}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">Email</div>
              <div class="view-value">{{com.comemail}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">单位网站</div>
              <div class="view-value">{{com.comwebaddr}}</div>
            </div>
            <div class="view-field" v-if="$store.getters.loginUser.comtype ===1 || $store.getters.loginUser.comtype ===2">
              <div class="view-label">业务员</div>
              <div class="view-value">{{com.salemanusername}}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">联系地址</div>
              <div class="view-value">{{com.comaddr}}</div>
            </div>
            <div class="view-field">
              <div class="view-label">业务范围</div>
              <div class="view-value">{{com.comremark}}</div>
            </div>
          </div>
          <div v-if="+com.comtype === 2">
            <div class="split-line"></div>
            <div class="view-row">
              <div class="view-field">
                <div class="view-label">与代理协同方式</div>
                <div class="view-value">{{+com.cositemapsynergyway===1?'线上协同':'线下协同' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 弹窗 -->
      <el-dialog
        title="查看附件"
        :visible.sync="dialogVisible"
        width="70%">
        <div class="addexport">
          <el-form :model="appendItem" ref="ruleAppend" label-position="right" class="mainfrom from_input">
            <el-form-item label="附件类型" prop="appendtype" verify>
              {{appendItem.appendtypedesc}}
            </el-form-item>
            <el-form-item label="上传附件" prop="appendurl" verify>
              <!-- <upload-pic-one :picUrl="appendItem.appendurl" folderName="com"
                              text="选择文件"></upload-pic-one> -->
                              
              <popover-img :img-src="appendItem.appendurl ? uploadAddr + appendItem.appendurl:''"
                          default-height="150"></popover-img>
              
            </el-form-item>
            <div class="row">
              <el-form-item label="附件编号">
                {{appendItem.appendfilecode}}
              </el-form-item>

              <el-form-item label="附件名称" prop="appendfilename" verify>
                {{appendItem.appendfilename}}
              </el-form-item>
            </div>

          </el-form>
        </div>
      </el-dialog>
      <div class="split-box">
        <div class="split-line"></div>
        <div class="split-name">【附件】</div>
      </div>
      <vggrid ref="xGrid" :list="list" tableheight="300" flexname="" :cols="cols"
              :showfooter="false" :showPage="false" :resizable="true"
              @cellDblClick="viewProject"
              :needBlackRow="false" :needPopMenu="false" :canbeEdit="false"
              @cellClick="cellClick" :isOperate="false">
      </vggrid>

      <div class="split-box">
        <div class="split-line"></div>
        <div class="split-name">【公司成员】</div>
      </div>

      <vggrid :list="comsuserList" tableheight="600" flexname="" :cols="comCols"
              :showfooter="false" :showPage="true" :resizable="true" @vggridClick="vggridClickCom"
              :total="query.total" @pagechange="pagechange" @cellClick="cellClickCom"
      >
          <template slot="btn">
            <div class="btn-box">
              <vxe-button type="text" icon="vxe-icon--plus" @click="addUser" :loading="btnLoading">新增</vxe-button>
              <!-- <vxe-button type="text" icon="vxe-icon--edit-outline" @click="chgUser" :loading="btnLoading">修改</vxe-button> -->
            </div>
          </template>
      </vggrid>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  import common from '@/mixin/common'
  import axios from 'axios'
  import popoverImg from '../common/popoverImg'
  import Dacform from "./dacForm"
  import uploadPicOne from '../common/uploadPicOne'

  const SUCCESS = 1
  export default {
    name: "comform",
    mixins: [common],
    data () {
      return {
        com: {},
        user:{},
        comtypeList: [],
        comtypes: [],
        list: [],
        btn: {},
        cols: [
          {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80},
          {field: 'appendtypedesc', fieldtype: 'C', title: '附件类型', calculExpr: ''},
          {field: 'appendfilecode', fieldtype: 'C', title: '文件编号', calculExpr: ''},
          {field: 'appendfilename', fieldtype: 'C', title: '文件名', calculExpr: ''}
          // { field: 'appendurl', fieldtype: 'C',title: 'URL',calculExpr:''}
        ],
        comCols:[
          {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 80},
          {field: 'usercode', fieldtype: 'C', title: '账号', calculExpr: ''},
          {field: 'username', fieldtype: 'C', title: '名称', calculExpr: ''},
          {field: 'rolename', fieldtype: 'C', title: '职务', calculExpr: ''},
          { title: '操作 ', showOverflow: true,width:100,
              slots: {
              default: ({row}) => {
                return [<vxe-button type="text" icon="vxe-icon--edit-outline" status="primary"  onClick={this.chgUser.bind(this, row)}></vxe-button>]
              }
              }
          }
        ],
        total:0,
        append: {},
        btnLoading: false,
        appendTypeList: [],
        appendItem: {},
        comsuserList: [],
        dialogVisible: false,
        query: {
          total: 0,
          limit: 20,
          offset: 0
        },
        iscomtypes: false //判断是否为代理和采购
      }
    },
    async activated () {
      await this.init()
      await this.getAppendList()
      await this.getComuser()
    },
    async created () {
      // await this.getComuser()
    },
    watch: {},
    filters: {},
    components: {Dacform, vggrid,uploadPicOne,popoverImg},
    deactivated () {
      this.com = {}
    },
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      async init () {
        this.appendTypeList = []
        this.append = {}
        this.btn = {}
        this.comtypeList = []
        this.appendItem = {}
        this.list = []
        this.comsuserList = []
        this.iscomtypes = false
        // await this.getComtype()
        if (this.$route.params.comid) {
          this.com.comid = this.$route.params.comid
        } else {
          this.com.comid = this.$store.getters.loginUser.usercomid
        }
        await this.getCom()
      },
      vggridClick (code, row) {
        this.append = row
        this.$emit(code, row)
      },
      vggridClickCom(code, row) {
        this.user = row
        this.$emit(code, row)
      },
      async getAppendType () {
        this.appendTypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'appendtype'}
        })
      },
      async get () {
        this.comtypeList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'cositemcomtype'}
        })
      },
      async getCom () {
        let data = await request({
          method: 'get',
          url: '/ywgl/com/getComById',
          params: {comid: this.com.comid}
        })
        console.log(data)
        if (data.length === 1) {
          this.com = data[0]
          this.com.comtype = this.com.comtype.toString()
        } else {
          this.com = {}
          // this.$message.error('找不到该平台单位')
          return
        }
      },
      async cellClick (row) {
        this.append = row.row
      },
      async cellClickCom(row){
        this.user = row.row
      },
      async getAppendList () {
        this.list = await request({
          url: '/ywgl/append/getPageList',
          method: "get",
          params: {appendfromid: this.com.comid, appendfromtype: 1}
        })
      },
      close () {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: 'comIndex'})
      },
      async viewProject(row) {
        this.append = row.row
        this.appendItem = _.cloneDeep(this.append)
        this.dialogVisible = true
      },
      async getcomsuserList () {
        let query = {
          comid: this.$store.getters.loginUser.usercomid
        }
        let res = await request({
          method: 'get',
          url: '/xtgl/user/getPageList',
          params: query
        })
        this.comsuserList = res.list
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getComuser()
      },
      async getComuser () {
        this.query.comid =  this.com.comid,
        this.query.cosid = this.$store.getters.loginUser.cosid
        let res = await request({
          method: 'get',
          url: '/xtgl/user/getComuserBycomid',
          params: this.query
        })
        this.comsuserList = res.list
        this.query.total = res.count[0].count
      },
      async addUser(){
          let form = {
              userid: 0,
              usercomid: this.$route.params.comid,
              userstatus: '1',
              comtype:this.com.comtype,
              userlockflg: '1'
          }
          this.$router.push({name: 'userForm', params: {form: form, type: 1}})
      },
      async chgUser(){
          if (!this.user.userid) {
          this.$message.warning('请选择一个用户!')
          return
          }
          this.$router.push({name: 'userForm', params: {form: this.user, type: 2}})
      },
    }
  }
</script>

<style lang="scss" scoped>
  .btn-box {
    overflow: hidden;
    .vxe-button {
      padding: 10px 10px;
      font-size: 16px;
    }
  }

  .main {
    margin-bottom: 50px;
    .value {
      width: 260px;
    }
    .content {
      width: 620px;
    }
  }
  .split-box{
    margin: 11px 0 15px;
    .split-line{
      margin: 5px;
    }
    .split-name{
      font-weight: bold;
    }
  }
</style>
